import React, { useEffect, useRef, useState } from "react";
import filterIcon from "../images/filterIcon.png";
import ContactTableDatabase from "./ContactTableDatabase";
import axios from "axios";
import SearchInputField from "./SearchInputField";
import {
  createDatabase,
  storeDataInIndexedDB,
  fetchDataFromIndexedDB,
  deleteDataFromIndexedDB,
} from "../Hooks/IndexedDBUtils";
import Select from "react-select";
import TagInput from "./TagInput";
import ConfigurableFilterFields from "./ConfigurableFilterFields";
import { TbFilterPin } from "react-icons/tb";
const { REACT_APP_BASE_URL } = process.env;

export const syncableWolkingListDB = createDatabase(
  "syncableWolkingListDB",
  "syncableWalkingListStore"
);

export const walkingListDB = createDatabase(
  "walkingListDB",
  "walkingListStore"
);
const WalkingList = () => {
  const [activeTab, setActiveTab] = useState("contacts");
  const [userData, setUserData] = useState([]);
  const [hideLoading, setHideLoading] = useState(false);
  const [searchFirstName, setSearchFirstName] = useState("");
  const [searchLastName, setSearchLastName] = useState("");
  const [searchAddress, setSearchAddress] = useState([]);
  const [searchAddress1, setSearchAddress1] = useState("");
  const [searchCity, setSearchCity] = useState("");
  const [searchZip, setSearchZip] = useState("");
  const [customFilterValues, setCustomFilterValues] = useState({});
  const [searchAge, setSearchAge] = useState("");
  const [searchState_income_decile, setState_income_decile] = useState("");
  const [searchNational_voter_cluster, setSearchNational_voter_cluster] =
    useState("");
  const [searchCensus_block, setSearchCensus_block] = useState("");
  const [searchPresence_of_children_code, setSearchpresence_of_children_code] =
    useState();
  const [filteredData, setFilteredData] = useState(userData);
  const token = localStorage.getItem("token");
  const userMail = localStorage.getItem("urserMail");
  const ownerID = localStorage.getItem("ownerId");
  const [page, setPage] = useState(1);
  const limit = 100;
  const [loading, setLoading] = useState(false);
  const [allDataLoaded, setAllDataLoaded] = useState(false);
  const db3 = walkingListDB;
  const [allCityOptions, setAllCityOptions] = useState([]);
  const [allCount, setAllCount] = useState("");
  const [listMemberData, setListMemberData] = useState([]);
  const [selectedMemberList, setSelectedMemberList] = useState("");
  const [offset, setOffset] = useState(0);
  const [isFiltered, setIsFiltered] = useState(false);
  const appliedFilterRef = useRef(null);
  const fetchIdRef = useRef(0);
  const reloadListRef = useRef(() => {});
  // Property visibility (see docs/implementation-plans/2026-09-15-property-visibility-survey-groups.md)
  // only governs which fields the edit modal renders - the table always
  // shows real values. Captured from the most recent /database response and
  // passed down to ContactTableDatabase for its edit modal.
  const [hiddenFields, setHiddenFields] = useState([]);
  const walking_sort = JSON.parse(localStorage.getItem("sortWalking")) || {};
  const [searchLanguages, setSearchLanguage] = useState("");
  const [searchEstimatedIncomeRange, setSearchEstimatedIncomeRange] =
    useState("");
  const getListMemberShipList = async () => {
    try {
      const res = await axios.get(
        `${REACT_APP_BASE_URL}/list_membership_contact`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setListMemberData(res?.data?.options);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (listMemberData?.length === 0) {
      getListMemberShipList();
    }
  }, []);
  const getCityOptions = async () => {
    try {
      const response = await axios.get(`${REACT_APP_BASE_URL}/getCity`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data) {
        const options = response.data.cities.map((city) => ({
          value: city.name,
          label: city.name,
        }));
        setAllCityOptions(options);
      }
    } catch (error) {
      console.error("Error fetching city data:", error);
    }
  };

  useEffect(() => {
    localStorage.removeItem("walkingListFilters");
    if (navigator.onLine) {
      fetchDataBase();
      getCityOptions();
    }
  }, []);

  useEffect(() => {
    setFilteredData(userData);
  }, [userData]);

  useEffect(() => {
    const handleSyncCompleted = () => {
      if (navigator.onLine) {
        reloadListRef.current();
      }
    };

    window.addEventListener("syncCompleted", handleSyncCompleted);
    return () => window.removeEventListener("syncCompleted", handleSyncCompleted);
  }, []);

  const fetchDataBase = async (customPage = null, key) => {
    if (!offset && navigator.onLine) {
      deleteDataFromIndexedDB(db3, "walkingListStore");
    }
    const reqId = ++fetchIdRef.current;
    setLoading(true);
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/database`,
        Object.keys(walking_sort)?.length > 0
          ? {
            offset: key === "RESET" ? 0 : offset,
            limit: limit,
            sort_by: walking_sort?.sortBy,
            direction: walking_sort?.direction?.toUpperCase(),
            owner_id: ownerID,
          }
          : {
            offset: key === "RESET" ? 0 : offset,
            limit: limit,
            owner_id: ownerID,
          },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (reqId !== fetchIdRef.current) return;
      setAllCount(response?.data?.total);
      setOffset(key === "RESET" ? 100 : offset + 100);
      setHiddenFields(response?.data?.hidden_fields || []);
      const newData = response.data.results;
      setAllDataLoaded(newData.length === 0);
      setUserData((prevData) =>
        customPage ? newData : [...prevData, ...newData]
      );
      key === "RESET" && localStorage.removeItem("walkingListFilters");
      setPage(customPage ? customPage + 1 : page + 1);

      if (newData.length > 0 && navigator.onLine) {
        storeDataInIndexedDB(db3, "walkingListStore", newData);
      }

      if (!response?.data?.paging) {
        setHideLoading(true);
        setAllDataLoaded(true);
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      if (reqId === fetchIdRef.current) {
        setLoading(false);
        setHideLoading(false);
      }
    }
  };

  useEffect(() => {
    fetchDataFromIndexedDB(db3, "walkingListStore").then((data) => {
      if (navigator.onLine === false) {
        setUserData(data);
      }
    });
  }, []);

  const handlePagination = () => {
    if (!loading && !allDataLoaded) {
      if (isFiltered) {
        filterOnline("", "", offset);
      } else {
        fetchDataBase();
      }
    }
  };
  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const filterOnline = async (customPage = null, key = null, reuseApplied = false) => {
    setHideLoading(true);
    const reqId = ++fetchIdRef.current;
    setLoading(true);
    key === "RESET" && setOffset(0);
    const liveBody = {
          owner_id: ownerID,
          firstname: searchFirstName,
          lastname: searchLastName,
          residence_address_line_1: searchAddress,
          residence_city: searchCity,
          residence_zip: searchZip,
          age: searchAge,
          limit: limit,
          state_income_decile: searchState_income_decile,
          census_block: searchCensus_block,
          national_voter_cluster: searchNational_voter_cluster,
          presence_of_children_code: searchPresence_of_children_code,
          list_membership: selectedMemberList,
          languages: searchLanguages,
          estimated_income_range: searchEstimatedIncomeRange,
          ...(Object.values(customFilterValues).some(Boolean) ? { custom_filters: customFilterValues } : {}),
          offset: key === "RESET" ? 0 : offset,
          ...(walking_sort
            ? {
              sort_by: walking_sort?.sortBy,
              direction: walking_sort?.direction?.toUpperCase(),
            }
            : ""),
    };
    const useApplied = appliedFilterRef.current && (key !== "RESET" || reuseApplied);
    const body = useApplied
      ? {
        ...appliedFilterRef.current,
        offset: key === "RESET" ? 0 : offset,
        ...(walking_sort?.sortBy ? { sort_by: walking_sort.sortBy, direction: walking_sort.direction?.toUpperCase() } : {}),
      }
      : liveBody;
    if (!useApplied) appliedFilterRef.current = body;
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/database`,
        body,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (reqId !== fetchIdRef.current) return;
      setAllCount(response?.data?.total);
      setHiddenFields(response?.data?.hidden_fields || []);
      if (response.status) {
        let newData = response?.data?.results;
        let allData = key === "RESET" ? newData : [...filteredData, ...newData];
        setFilteredData(allData);
        setUserData(allData);
        setOffset((prev) => prev + 100);
        storeDataInIndexedDB(db3, "walkingListStore", allData);
      }

      localStorage.setItem("walkingListFilters", JSON.stringify(appliedFilterRef.current));

      if (!response?.data?.paging) {
        setHideLoading(true);
        setAllDataLoaded(true);
      } else {
        setHideLoading(false);
        setAllDataLoaded(false);
      }
    } catch (error) {
      console.error("API error:", error);
    } finally {
      if (reqId === fetchIdRef.current) {
        setLoading(false);
        setHideLoading(false);
      }
    }
  };
  const filterOffline = (e) => {
    let filtered = userData.slice();
    if (searchFirstName) {
      filtered = filtered.filter(
        (user) =>
          user.properties.firstname &&
          user.properties.firstname
            .toLowerCase()
            .includes(searchFirstName.toLowerCase())
      );
    }
    if (searchLastName) {
      filtered = filtered.filter(
        (user) =>
          user.properties.lastname &&
          user.properties.lastname
            .toLowerCase()
            .includes(searchLastName.toLowerCase())
      );
    }
    const addressTerms = [].concat(searchAddress).filter(Boolean);
    if (addressTerms.length > 0) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_address_line_1 &&
          addressTerms.some((term) =>
            user.properties.residence_address_line_1.toLowerCase().includes(String(term).toLowerCase())
          )
      );
    }
    if (searchCity) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_city &&
          user.properties.residence_city
            .toLowerCase()
            .includes(searchCity.toLowerCase())
      );
    }
    if (searchZip) {
      filtered = filtered.filter(
        (user) =>
          user.properties.residence_zip &&
          user.properties.residence_zip.includes(searchZip)
      );
    }
    if (searchAge) {
      filtered = filtered.filter(
        (user) =>
          user.properties.age && user.properties.age === parseInt(searchAge)
      );
    }
    if (searchState_income_decile) {
      filtered = filtered.filter(
        (user) =>
          user.properties.state_income_decile &&
          user.properties.state_income_decile ===
          parseInt(searchState_income_decile)
      );
    }
    if (searchCensus_block) {
      filtered = filtered.filter(
        (user) =>
          user.properties.census_block &&
          user.properties.census_block.includes(searchCensus_block)
      );
    }
    if (searchNational_voter_cluster) {
      filtered = filtered.filter(
        (user) =>
          user.properties.national_voter_cluster &&
          user.properties.national_voter_cluster ===
          searchNational_voter_cluster
      );
    }
    if (searchPresence_of_children_code) {
      filtered = filtered.filter(
        (user) =>
          user.properties.presence_of_children_code &&
          user.properties.presence_of_children_code ===
          searchPresence_of_children_code
      );
    }
    if (selectedMemberList) {
      filtered = filtered.filter(
        (user) =>
          user.properties.list_membership &&
          user.properties.list_membership === selectedMemberList
      );
    }
    if (searchLanguages) {
      filtered = filtered.filter(
        (user) =>
          user.properties.languages &&
          user.properties.languages === searchLanguages
      );
    }
    if (searchEstimatedIncomeRange) {
      filtered = filtered.filter(
        (user) =>
          user.properties.estimated_income_range &&
          user.properties.estimated_income_range === searchEstimatedIncomeRange
      );
    }
    setFilteredData(filtered);
  };

  const applyFilters = (e) => {
    e.preventDefault();
    setIsFiltered(true);

    setOffset(0);
    if (navigator.onLine) {
      deleteDataFromIndexedDB(db3, "walkingListStore");
      filterOnline(1, "RESET");
    } else {
      filterOffline();
    }
  };

  const sortDatabase = async (sortBy, direction, customPage = null) => {
    const reqId = ++fetchIdRef.current;
    setLoading(true);
    let walkDB = {
      sortBy: sortBy,
      direction: direction,
    };
    localStorage.setItem("sortWalking", JSON.stringify(walkDB));

    const filterdata = isFiltered ? JSON.parse(localStorage.getItem("walkingListFilters")) : null;
    if (navigator.onLine) {
      try {
        const response = await axios.post(
          `${REACT_APP_BASE_URL}/database`,
          filterdata
            ? {
              ...filterdata,
              owner_id: ownerID,
              offset: 0,
              limit: limit,
              sort_by: sortBy,
              direction: direction.toUpperCase(),
            }
            : {
              owner_id: ownerID,
              offset: 0,
              limit: limit,
              sort_by: sortBy,
              direction: direction.toUpperCase(),
            },
          {
            headers: {
              "Content-Type": "application/json",
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (reqId !== fetchIdRef.current) return;
        if (response.status) {
          const newData = response.data.results;
          setAllDataLoaded(newData.length === 0);
          setUserData((prevData) =>
            customPage ? newData : [...prevData, ...newData]
          );
          setPage(customPage ? customPage + 1 : page + 1);
          if (newData.length > 0) {
            storeDataInIndexedDB(db3, "walkingListStore", newData);
          }
          setOffset(100);
        }
        if (!response?.data?.paging) {
          setHideLoading(true);
          setAllDataLoaded(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      } finally {
        if (reqId === fetchIdRef.current) {
          setLoading(false);
          setHideLoading(false);
        }
      }
    } else {
      const sortedData = [...userData].sort((a, b) => {
        if (direction === "ascending") {
          return a.properties[sortBy] > b.properties[sortBy] ? 1 : -1;
        } else {
          return a.properties[sortBy] < b.properties[sortBy] ? 1 : -1;
        }
      });
      setUserData(sortedData);
      setLoading(false);
      setHideLoading(false);
    }
  };

  const sortDatabaseFirstNameDescending = async (customPage = null) => {
    await sortDatabase("firstname", "descending", customPage);
  };
  const sortDatabaseFirstNameAscending = async (customPage = null) => {
    await sortDatabase("firstname", "ascending", customPage);
  };
  const sortDatabaseLastNameDescending = async (customPage = null) => {
    await sortDatabase("lastname", "descending", customPage);
  };
  const sortDatabaseLastNameAscending = async (customPage = null) => {
    await sortDatabase("lastname", "ascending", customPage);
  };
  const sortDatabaseAddressDescending = async (customPage = null) => {
    await sortDatabase("residence_address_line_1", "descending", customPage);
  };
  const sortDatabaseAddressAscending = async (customPage = null) => {
    await sortDatabase("residence_address_line_1", "ascending", customPage);
  };
  const sortDatabaseZipDescending = async (customPage = null) => {
    await sortDatabase("residence_zip", "descending", customPage);
  };
  const sortDatabaseZipAscending = async (customPage = null) => {
    await sortDatabase("residence_zip", "ascending", customPage);
  };

  const [dataProperty, setDataproperty] = useState([]);
  const DatabaseProperty = async () => {
    let data = "";
    try {
      const response = await axios.post(
        `${REACT_APP_BASE_URL}/databaseProperties`,
        data,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response?.data) {
        setDataproperty(response.data);
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };
  useEffect(() => {
    if (navigator.onLine) {
      DatabaseProperty();
    }
  }, []);

  const reloadList = () => {
    if (isFiltered && appliedFilterRef.current) {
      filterOnline(1, "RESET", true);
    } else {
      fetchDataBase(1, "RESET");
    }
  };
  reloadListRef.current = reloadList;

  const handleReset = () => {
    setIsFiltered(false);
    appliedFilterRef.current = null;
    setCustomFilterValues({});
    setSearchFirstName("");
    setSearchLastName("");
    setSearchAddress([]);
    setSearchAddress1("");
    setSearchCity("");
    setSearchZip("");
    setSearchAge("");
    setState_income_decile("");
    setSearchNational_voter_cluster("");
    setSearchCensus_block("");
    setSearchpresence_of_children_code("");
    setSearchLanguage("");
    setSearchEstimatedIncomeRange("");
    setSelectedMemberList("");
    setOffset(0);
    localStorage.removeItem("sortWalking");
    localStorage.removeItem("walkingListFilters");
    if (navigator.onLine) deleteDataFromIndexedDB(db3, "walkingListStore");

    if (navigator.onLine) {
      fetchDataBase(1, "RESET");
    } else {
      fetchDataFromIndexedDB(db3, "walkingListStore").then((data) => {
        setUserData(data || []);
      });
    }
  };

  return (
    <div>
      <div className=" flex justify-between flex-wrap items-center bg-canvas-white py-3">
        <div className="flex items-center gap-8 pl-5 ">
          <div
            className={` text-canvas-directoryText py-2 flex gap-3 items-center cursor-pointer uppercase ${activeTab === "contacts" &&
              "border-b-2 border-canvas-primary text-canvas-primary"
              }`}
            onClick={() => handleTabClick("contacts")}
          >
            <h6 className="font-semibold">Contacts</h6>(
            {navigator.onLine ? allCount : userData.length})
          </div>
        </div>
        <div></div>
        <div className="flex items-center gap-8 px-5 border-x-2"></div>
        <div className="flex gap-5 items-center pr-5">
          <button type="button" data-hs-overlay="#hs-basic-modal">
            <img className="w-5 h-5" src={filterIcon} alt="filterIcon" />
          </button>
          <button type="button" data-hs-overlay="#hs-search-address-modal">
            <TbFilterPin className="w-5 h-5" />
          </button>

          <button
            className="p-2 bg-canvas-secondery bg-opacity-30 rounded"
            // onClick={() => fetchDataBase(1, "RESET")}
            onClick={handleReset}
          >
            Reset
          </button>
        </div>
      </div>
      {activeTab === "contacts" && (
        <ContactTableDatabase
          IDBtype="walking"
          dataProperty={dataProperty}
          sortDatabaseFirstNameDescending={sortDatabaseFirstNameDescending}
          sortDatabaseFirstNameAscending={sortDatabaseFirstNameAscending}
          sortDatabaseLastNameDescending={sortDatabaseLastNameDescending}
          sortDatabaseLastNameAscending={sortDatabaseLastNameAscending}
          sortDatabaseAddressDescending={sortDatabaseAddressDescending}
          sortDatabaseAddressAscending={sortDatabaseAddressAscending}
          sortDatabaseZipDescending={sortDatabaseZipDescending}
          sortDatabaseZipAscending={sortDatabaseZipAscending}
          fetchDataBase={fetchDataBase}
          setFilteredData={setFilteredData}
          filteredData={filteredData}
          userData={userData}
          loading={loading}
          db3={db3}
          syncableWolkingListDB={syncableWolkingListDB}
          hiddenFields={hiddenFields}
        />
      )}

      {!allDataLoaded &&
        !hideLoading &&
        filteredData?.length >= 10 &&
        navigator.onLine && (
          <div className="w-full flex items-center justify-center p-5">
            <button
              type="button"
              className="py-2 px-3 inline-flex items-center justify-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white disabled:cursor-progress"
              onClick={handlePagination}
              disabled={loading}
            >
              {loading ? "Loading..." : "Load More"}
            </button>
          </div>
        )}
      {/* search Model */}
      <div
        id="hs-basic-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-2xl  m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto max-h-[800px]">
            <div className="p-4 overflow-y-auto">
              <h4 className="pb-5 flex justify-center">
                Max. 3 search together allowed.
              </h4>
              <form className="w-full" onSubmit={(e) => applyFilters(e)}>
                <ConfigurableFilterFields
                  page="walking_list"
                  dataProperty={dataProperty}
                  bindings={{
                    firstname: [searchFirstName, setSearchFirstName],
                    lastname: [searchLastName, setSearchLastName],
                    residence_zip: [searchZip, setSearchZip],
                    age: [searchAge, setSearchAge],
                    state_income_decile: [searchState_income_decile, setState_income_decile],
                    national_voter_cluster: [searchNational_voter_cluster, setSearchNational_voter_cluster],
                    census_block: [searchCensus_block, setSearchCensus_block],
                    presence_of_children_code: [searchPresence_of_children_code, setSearchpresence_of_children_code],
                    languages: [searchLanguages, setSearchLanguage],
                    estimated_income_range: [searchEstimatedIncomeRange, setSearchEstimatedIncomeRange],
                  }}
                  renderers={{
                    residence_address_line_1: () => (
                      <SearchInputField
                        label="Street Address"
                        value={searchAddress1}
                        onChange={(e) => {
                          setSearchAddress1(e.target.value);
                          setSearchAddress([e.target.value]);
                        }}
                      />
                    ),
                    residence_city: () => (
                      <div className="md:flex md:items-center mb-6">
                        <div className="md:w-1/3">
                          <label
                            className="block text-gray-500 font-bold text-left mb-1 md:mb-0 pr-4"
                            htmlFor="input-field"
                          >
                            City
                          </label>
                        </div>
                        <div className="md:w-2/3">
                          <Select
                            id="city"
                            name="city"
                            className="bg-gray-200 appearance-none border-none border-gray-200 rounded w-full  text-gray-700 leading-tight focus:outline-none "
                            options={allCityOptions}
                            value={allCityOptions.find(
                              (option) => option.value === searchCity
                            )}
                            onChange={(selectedOption) =>
                              setSearchCity(
                                selectedOption ? selectedOption.value : null
                              )
                            }
                            isClearable
                          />
                        </div>
                      </div>
                    ),
                  }}
                  customValues={customFilterValues}
                  onCustomChange={(key, value) =>
                    setCustomFilterValues((prev) => ({ ...prev, [key]: value }))
                  }
                />

                <SearchInputField
                  label={<>List Membership</>}
                  value={selectedMemberList}
                  onChange={(e) => setSelectedMemberList(e.target.value)}
                  type={"select"}
                  options={listMemberData}
                />

                <div className="flex justify-end items-center gap-x-2">
                  <button
                    type="submit"
                    className="py-3 px-6 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white "
                    data-hs-overlay="#hs-basic-modal"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
      <div
        id="hs-search-address-modal"
        className="hs-overlay hs-overlay-open:opacity-100 hs-overlay-open:duration-500 hidden size-full fixed top-0 start-0 z-[80] opacity-0 overflow-x-hidden transition-all overflow-y-auto pointer-events-none"
      >
        <div className="hs-overlay-open:opacity-100 hs-overlay-open:duration-500 opacity-0 transition-all sm:max-w-2xl  m-3 sm:mx-auto">
          <div className="flex flex-col bg-white border shadow-sm rounded-xl pointer-events-auto max-h-[800px]">
            <div className="p-4 overflow-y-auto">
              <h4 className="pb-5 flex justify-center">
                Max. 3 address search allowed.
              </h4>
              <form className="w-full" onSubmit={(e) => applyFilters(e)}>
                <TagInput
                  label={'Street Address'}
                  value={searchAddress}
                  setValue={setSearchAddress}
                />
                <div className="flex justify-center items-center gap-x-2 py-3 px-4 dark:border-gray-700">
                  <button
                    type="submit"
                    className="py-2 px-3 inline-flex items-center gap-x-2 text-sm font-medium rounded-lg border border-gray-200 bg-canvas-primary text-canvas-white "
                    data-hs-overlay="#hs-search-address-modal"
                  >
                    Search
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default WalkingList;
